import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Layers } from "lucide-react";

interface ITearOff {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}
export function TearOff(props: ITearOff) {
    const { value, onChange, loading } = { ...props };
    const [tearOff, setTearOff] = useState<string>("");

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setTearOff(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setTearOff(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Tear off Layers
            </Typography>

            <Select
                placeholder="Select tear off layer"
                value={tearOff || ""}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Layers size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                {tearOffLayers.map((layer) => (
                    <Option key={layer.label} value={layer.label}>
                        {layer.description}
                    </Option>
                ))}
            </Select>
        </Box>
    );
}

const tearOffLayers = [
    { label: "0", description: "0" },
    { label: "1", description: "1" },
    { label: "2", description: "2" },
    { label: "3", description: "3" },
    { label: "4", description: "4" },
];
